import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { HandleError } from 'src/app/shared/services/handle-error.service';
import { MenuTree } from 'src/app/shared/models/menu-tree.model';
import { OpcionesMenuEntry } from 'src/app/shared/entrys/opciones-menu.entry';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class MenuService {
	private handleError: HandleError;
	private API_URL;

	constructor(private http: HttpClient, private authService: AuthService, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(usuario: string): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/opcionesporusuario`).pipe(
			retry(2)
		);
	}

	setRoles(roles: any) {
		sessionStorage.setItem('roles', JSON.stringify(roles));
	}

	getRoles(): OpcionesMenuEntry {
		return this.authService.isToken() ? JSON.parse(sessionStorage.getItem('roles')) : null;
	}

	buildFileTree(obj: object, level: number): MenuTree[] {
		return Object.keys(obj).reduce<MenuTree[]>((accumulator, key) => {
			const value = obj[key];
			const node = new MenuTree();

			if (value.descripcion) {
				node.filename = obj[key].descripcion;
				if (value.hijos) {
					node.hijos = this.buildFileTree(value.hijos, level + 1);
				} else {
					node.ruta_url = value.ruta_url;
				}
			}
			return accumulator.concat(node);
		}, []);
	}
}
